/**
 * Inserts Cloudinary transformation parameters into an image URL.
 * Works by injecting between `/upload/` and the rest of the path.
 *
 * Example:
 *   .../upload/v123/blog/image.jpg
 *   → .../upload/w_800,f_auto,q_auto/v123/blog/image.jpg
 */
export function cloudinaryImg(url, { width, quality = 'auto', format = 'auto' } = {}) {
  if (!url || !url.includes('res.cloudinary.com')) return url;
  const transforms = [
    width ? `w_${width}` : null,
    `f_${format}`,
    `q_${quality}`,
  ].filter(Boolean).join(',');
  return url.replace('/upload/', `/upload/${transforms}/`);
}
